const PortfolioAssetCategories = [
  "Equity",
  "Fixed Income",
  "Alternative",
  "Balanced",
  "Cash",
  "Unidentified",
  "Other",
] as const;

const unknownCategory = (name: string): boolean =>
  PortfolioAssetCategories.some((c) => c === name) === false;

export default unknownCategory;
